import { render } from "./EditInverterPage.vue?vue&type=template&id=cbd456ca"
import script from "./EditInverterPage.vue?vue&type=script&lang=js"
export * from "./EditInverterPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__